import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getNewArrival = createAsyncThunk(
  "getNewArrival",
  async (object, { getState, rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        "/api/Products/GetProductsWithOrder"
      );

      return data;
    } catch (error) {
      rejectWithValue(error.response);
    }
  }
);

const loremSlice = createSlice({
  name: "lorem",
  initialState: {
    data: [],
    loading: false,
    isSuccess: false,
    message: "",
  },
  reducers: {},
  extraReducers: {
    [getNewArrival.pending]: (state, action) => {
      state.loading = true;
    },
    [getNewArrival.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
      state.isSuccess = true;
    },
    [getNewArrival.rejected]: (state, { payload }) => {
      state.loading = false;
      state.isSuccess = false;
      state.message = "failed";
    },
  },
});

export default loremSlice;